<template>
	<ClientOnly>
		<CardGeneric class="text-center cardSpacing !px-8 !py-8 lg:!py-40 customEmptyCartContainer">
			<IconsFontAwesome
				id="emptyCartIcon"
				icon="fa-solid fa-shopping-cart"
				class="text-ternary opacity-60 my-6" />
			<p class="text-ternary my-6 text-center text-xl opacity-70">{{ $t("emptyCart") }}</p>
		</CardGeneric>
	</ClientOnly>
</template>

<script setup></script>

<style>
	#emptyCartIcon svg {
		@apply h-16;
	}
</style>
